import { render, staticRenderFns } from "./editChetou.vue?vue&type=template&id=25659b6f&scoped=true&"
import script from "./editChetou.vue?vue&type=script&lang=js&"
export * from "./editChetou.vue?vue&type=script&lang=js&"
import style0 from "./editChetou.vue?vue&type=style&index=0&id=25659b6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25659b6f",
  null
  
)

export default component.exports